import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {lighten} from "polished";

interface IProps {
    label?: JSX.Element | string;
    groupClassName?: string;
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
    name: string;
    value: number;
    onChange: (name: string, value: number) => void;
}

export const FiltersSelectRangeSingleElement = (props: IProps) => {
    const onChange = () => {
        if (props.isNonActive) {
            return;
        }

        if (props.isDisabled) {
            return;
        }
        props.onChange(props.name, props.value);
    };

    return (
        <CheckboxHolder isActive={props.isActive} isNonActive={props.isNonActive} isDisabled={props.isDisabled} onClick={onChange}>
            <span>{props.label}</span>
        </CheckboxHolder>
    );
};

interface ICheckboxHolder {
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
}

const CheckboxHolder = styled.div<ICheckboxHolder>`
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) =>
        props.isDisabled
            ? css`
                  cursor: not-allowed;
                  color: #ccc;
              `
            : css`
                  cursor: pointer;
              `}
    background: ${(props) => props.isActive && (props.isNonActive ? "#ececec" : props.theme.colors.primary)};

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        &:hover {
            background: ${(props) => (props.isActive ? (props.isNonActive ? "#f2f2f2" : lighten(0.05, "#ccc")) : "#f9f9f9")};
        }
    }
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {lighten} from "polished";

interface IProps {
    label?: JSX.Element | string;
    groupClassName?: string;
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
    name: string;
    value: number;
    onChange: (name: string, value: number) => void;
}

export const FiltersSelectRangeSingleElement = (props: IProps) => {
    const onChange = () => {
        if (props.isNonActive) {
            return;
        }

        if (props.isDisabled) {
            return;
        }
        props.onChange(props.name, props.value);
    };

    return (
        <CheckboxHolder isActive={props.isActive} isNonActive={props.isNonActive} isDisabled={props.isDisabled} onClick={onChange}>
            <span>{props.label}</span>
        </CheckboxHolder>
    );
};

interface ICheckboxHolder {
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
}

const CheckboxHolder = styled.div<ICheckboxHolder>`
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) =>
        props.isDisabled
            ? css`
                  cursor: not-allowed;
                  color: #ccc;
              `
            : css`
                  cursor: pointer;
              `}
    background: ${(props) => props.isActive && (props.isNonActive ? "#ececec" : props.theme.colors.primary)};

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        &:hover {
            background: ${(props) => (props.isActive ? (props.isNonActive ? "#f2f2f2" : lighten(0.05, "#ccc")) : "#f9f9f9")};
        }
    }
`;
